export default __webpack_public_path__ + "static/media/Care13.78a7d039.png";